import React from 'react';
import SearchTextBox from './search-textbox';
import SearchResults from './search-results';

const ExploreSearchPage = () => {

    return (
        <div className="waves-box-lg mx-auto px-5 md:px-12 xl:px-0 mb-24 overflow-hidden">

            <div className="w-full flex items-center justify-center mb-10">
                <SearchTextBox/>
            </div>

            <SearchResults/>
        </div>
    )
};

export default ExploreSearchPage;